import React, { useMemo } from 'react';
import { OptionKey, SelectDropdown } from '@common-fe/common-fe';

import { ALL_OPTION_KEY } from '@/common/constants';
import { useSelectAllHandler } from '@/modules/core';

import { ENROLLMENT_STATUS_OPTIONS } from '../../report.types';

interface Props {
  testId?: string;
  values: OptionKey[];
  disabled?: boolean;
  onChangeValues: (value: OptionKey[]) => void;
}
const EnrollmentStatusDropdown: React.FC<Props> = ({
  testId = 'enrollment-status-dropdown',
  disabled,
  values,
  onChangeValues,
}) => {
  const currentValue = useMemo(() => {
    if (!values.length && !disabled) {
      return [ALL_OPTION_KEY];
    }
    return values;
  }, [disabled, values]);

  const handleChangeValue = useSelectAllHandler(values, onChangeValues);

  return (
    <SelectDropdown
      key="enrollment-status"
      ellipsisMode
      disabled={disabled}
      activeTitle
      testId={testId}
      options={ENROLLMENT_STATUS_OPTIONS}
      values={currentValue}
      onChangeValues={handleChangeValue}
      prefix="Enrollment status"
      id="enrollment_selector"
      name="enrollment e_selector"
      allMode
    />
  );
};

export default EnrollmentStatusDropdown;
